module.exports = __webpack_public_path__ + "img/16.f480f741.jpg";